import React from "react";
import {useForm, usePage} from "@inertiajs/react";
import {Button, Card, Col, Container, Form, Row} from "react-bootstrap";
import NoNewsletterBanner from "../../../Components/Campaigns/NoNewsletterBanner.jsx";
import HtmlEditor from "../../../Components/Campaigns/HtmlEditor.jsx";

/**
 * Anlage/Bearbeitung einer Signatur-Vorlage.
 */
export default function Edit() {
    const {signature} = usePage().props;
    const {data, setData, post, processing, errors} = useForm({
        name: signature?.name ?? "",
        html: signature?.html ?? "",
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        if (signature) {
            post(`/campaigns/signatures/${signature.id}`);
        } else {
            post("/campaigns/signatures");
        }
    };

    return (
        <Container fluid className="p-4">
            <NoNewsletterBanner/>
            <Form onSubmit={handleSubmit} noValidate>
                <Card className="mt-3">
                    <Card.Header>
                        <div className="d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">{signature ? `Signatur bearbeiten - ${signature.name}` : "Neue Signatur"}</h5>
                            <Button type="submit" disabled={processing}>Speichern</Button>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2}>Name</Form.Label>
                            <Col sm={10}>
                                <Form.Control id="name" value={data.name} onChange={(e) => setData("name", e.target.value)}
                                              className={errors.name ? "is-invalid" : ""}/>
                                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2}>Inhalt</Form.Label>
                            <Col sm={10}>
                                <HtmlEditor value={data.html} onChange={(html) => setData("html", html)}/>
                                {errors.html && <div className="text-danger mt-1">{errors.html}</div>}
                            </Col>
                        </Form.Group>
                    </Card.Body>
                </Card>
            </Form>
        </Container>
    );
}
